import { Grid, Paper, Typography } from '@mui/material'
import React, { useContext } from 'react'
import cilindro from '../../../assets/images/Cilindros.jpg'
import estacionario from '../../../assets/images/Estacionario.jpg'
import styled from '@emotion/styled'
// import { useContext } from 'react'
import { AppContext } from '../../../context'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { filterAccountsbyService, getTypeAccount } from '../../../slices/accountsSlice'
import { setTypeService } from '../../../slices/fillAddressSlice'
import { addActiveClass, addHoverClass } from '../../../styles'

export const Products = () => {
   const { handleIsOpen } = useContext(AppContext)
   const dispatch = useDispatch()
   const navigate = useNavigate()

   const handleNavigate = (type) => {
      dispatch( filterAccountsbyService(type) )
      dispatch(getTypeAccount(type))
      navigate(`/dashboard/accounts/${type.toLowerCase()}`)
   }

   const Image = styled('img')(() => ({
      width: '100%',
      height: 130,
      objectFit: 'cover',
      // borderTopLeftRadius: 10,
      // borderTopRightRadius: 10,
   }))

   const CustomText = styled(Typography)(() => ({
      // textAlign: 'center',
      padding: 20
   }))




  return (
   <>
      <Grid container spacing={1} >
         <Grid item xs={6}  onClick={ handleIsOpen } >
            <Paper onClick={ () => handleNavigate('PORTATIL') } sx={{ overFlow: 'hidden', borderTopLeftRadius: 5,borderTopRightRadius: 5 , cursor: 'pointer', ...addActiveClass, ...addHoverClass }}>
               <Image src={ cilindro } alt="" />
               <CustomText component="p" variant="h6">Cilindros</CustomText>
            </Paper>
         </Grid>
         <Grid item xs={6} onClick={ handleIsOpen } >
            <Paper onClick={() => handleNavigate('ESTACIONARIO')} sx={{ overFlow: 'hidden', borderTopLeftRadius: 5,borderTopRightRadius: 5 , cursor: 'pointer', ...addActiveClass, ...addHoverClass }}>
               <Image src={ estacionario } alt="" />
               <CustomText component="p" variant="h6">Estacionario</CustomText>
            </Paper>
         </Grid>
      </Grid>
   </>
  )
}
